import {composeDetailUrlFromUniqueId} from "@src/common/service/urlHandler";
import {howLongAgo} from "@src/common/service/dateFormatter";
import {splitSalaryText} from "../../../common/common/service/SalaryFormatter";
import {JobType} from "./job_panel_parts/JobType";
import {SimpleJobSummary} from "./job_panel_parts/SimpleJobSummary";

/**
 * 求人パネル
 *
 * @param props
 * @return {JSX.Element}
 * @constructor
 */
export const SimpleJobPanel = (props) => {
    // 給与文字列を給与額と給与種別に分割
    const splitSalary = splitSalaryText(props.viewedJob.salary);
    const salaryAmount = splitSalary.salaryAmount;
    const salaryType = splitSalary.salaryType;

    return (
        <li className="p-job s-biggerLink_wrap">
            <div className="p-job_cont">
                <p className="p-job_title">
                    <a
                        href={composeDetailUrlFromUniqueId(props.viewedJob.uniqueId)}
                        className="s-biggerLink"
                        onClick={(e) => e.preventDefault()}
                        rel="nofollow"
                    >{props.viewedJob.title}</a>
                </p>
                <div className="p-job_detail">
                    <SimpleJobSummary viewedJob={props.viewedJob} translations={props.modalViewModel.translations} />
                    {salaryAmount && <div className="p-job_salary">{salaryAmount}<span className="p-job_salary_per">{salaryType}</span></div>}
                    <JobType viewedJob={props.viewedJob} translations={props.modalViewModel.translations} />
                </div>
            </div>
            <div className="p-job_bottom">
                <p className="p-job_source">{howLongAgo(props.viewedJob.addTime, props.modalViewModel.translations)}</p>
            </div>
        </li>
    );
}
